<template>
  <div class="_make-article">

    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">ตอบกลับข้อความด้วยเว็บวิว (Webview)</h1>
    </header>

     <v-layout row wrap class="hidden-sm-and-down" style="width: 70vw;">
      <v-flex xl3 lg3 md3 style="text-align: center;">
    <div style="text-align: center;">
      <img src="/static/img/docs/webview.gif" style="width: 170px;" />
    </div>
  </v-flex>
        <v-flex xl9 lg9 md9 style="text-align: left;">
    <div class="MarkdownContent">
      <br>
      <br>
      <p class="preindent" style="width: 70%; margin-top: 80px;">เป็น API ที่ใช้สำหรับการส่งเว็บไซต์ หาบุคคลอื่น โดยทำการกำหนดห้องแชทที่ต้องการส่งถึง ส่งได้ทั้งห้องแชทส่วนตัวและแชทกลุ่ม
      </p>

      <p class="preindent" style="width: 70%;">สามารถนำมาประยุกต์ใช้กับงานได้หลากหลาย เพียงแค่คุณมีเว็บไซต์ไม่ว่าจะเป็นการกรอกแบบฟอร์ม การแสดงข้อมูลประชาสัมพันธ์ ก็นำมาเป็นส่วนหนึ่งในแชทเราได้โดยง่าย
      </p>
    </div>
  </v-flex>
</v-layout>

<div class="MarkdownContent hidden-md-and-up">
      <p class="preindent" style="width: 70vw;">เป็น API ที่ใช้สำหรับการส่งเว็บไซต์ หาบุคคลอื่น โดยทำการกำหนดห้องแชทที่ต้องการส่งถึง ส่งได้ทั้งห้องแชทส่วนตัวและแชทกลุ่ม</p>
      <p class="preindent" style="width: 70vw;">สามารถนำมาประยุกต์ใช้กับงานได้หลากหลาย เพียงแค่คุณมีเว็บไซต์ไม่ว่าจะเป็นการกรอกแบบฟอร์ม การแสดงข้อมูลประชาสัมพันธ์ ก็นำมาเป็นส่วนหนึ่งในแชทเราได้โดยง่าย
      </p>
    </div>

<div style="text-align: center;" class="hidden-md-and-up">
      <img src="/static/img/docs/webview.gif" style="width: 200px;" />
    </div>



    <header class="EndpointHeader">
      <h2 class="EndpointTitle">API ส่งเว็บวิว</h2>-
        <span class="EndpointVerbPost">POST</span>
        <span class="EndpointUrl">{{urlsendfile}}
          <v-icon class="urlcopy" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlsendfile">file_copy</v-icon>
        </span>
    </header>
    <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
    <h3>Request Parameter (JSON)</h3>
    <code class="codecolor" style="">
      <v-tooltip top >
        <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
              <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
               <span>Copy to clipboard</span>
            </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"Uba7xxx6c384xxxa5b3xxxx269b4xxxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150xxxx5d81axxxxxf34b95f218xxxxx"</span>,
    <span class="colorkey">"type"</span> : <span class="colorvalue">"web"</span>,
    <span class="colorkey">"url"</span> : <span class="colorvalue">"https://one.th/"</span>,
    <span class="colorkey">"custom_notification"</span> : <span class="colorvalue">"เปิดอ่านข้อความใหม่จากทางเรา"</span>
  }
    </code>

      <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งไฟล์</h3> -->
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>to</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>ประเภทของข้อความ ในที่นี้เป็น web</td>
        </tr>
        <tr>
          <td>url</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>url ของwebsite ที่ต้องการจะส่ง โดยมีรูปแบบของurlปกติ</td>
        </tr>
        <tr>
          <td>custom_notification</td>
          <td>String</td>
          <td></td>
          <td>ข้อมูลสำหรับแสดงการแจ้งเตือน</td>
        </tr>
      </table>

<br>
      <header class="EndpointHeader">
        <h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbPost">200 OK</span>
          <span class="EndpointUrl">กรณีที่ส่ง request มาถูกต้อง</span>
      </header>

<code class="codecolor">
<v-tooltip top >
<v-btn flat icon type="button" class="responsefile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageresponsestick">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"message"</span> : {
      <span class="colorkey">"id"</span> : <span class="colorvalue">"5bbxxxxx14e06xxx4b1xxxxx"</span>,
      <span class="colorkey">"url"</span> : <span class="colorvalue">"https://one.th/"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"web"</span>
    },
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">1539144164000</span>,
    <span class="colorkey">"type_source"</span> : <span class="colorvalue">"bot"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150xxxx5d81axxxxxf34b95f218xxxxx"</span>,
    <span class="colorkey">"type_destination"</span> : <span class="colorvalue">"user"</span>,
    <span class="colorkey">"user_id"</span> : <span class="colorvalue">"Uba7xxx6c384xxxa5b3xxxx269b4xxxxx"</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>
      <!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งไฟล์</h3> -->
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>message</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลทั้งหมด ที่เกี่ยวกับข้อความนั้น ๆ ประกอบด้วย
            <ul>
            <li>id คือ เลขเฉพาะที่บ่งบอกถึงข้อความนั้น ๆ</li>
            <li>url คือ ข้อความที่ถูกส่ง ซึ่งจะเป็น url ของ website</li>
            <li>type คือ ประเภทข้อความที่ถูกส่ง ในที่นี้เป็น "web"</li>
          </ul>
          </td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>วันและเวลาที่ส่งข้อความ</td>
        </tr>
        <tr>
          <td>type_source</td>
          <td>String</td>
          <td>ประเภทของบุคคลที่ส่งข้อความ ซึ่งจะเป็น bot หรือ user</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type_destination</td>
          <td>String</td>
          <td>ประเภทของห้องแชทที่ส่ง ซึ่งจะเป็น user หรือ group</td>
        </tr>
        <tr>
          <td>user_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบุคคลนั้น</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          </td>
        </tr>
      </table>

      <!-- 401 Authorization fail -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีที่ส่ง Authorization มาผิด</span>
      </header>

      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageauthoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization fail."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Authorization fail."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND to-->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง to มาผิด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messagetoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"User ID not found."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด <br>
            <ul>
            <li>"User ID not found."</li>
            <li>"Group ID not found."</li>
            <li>"Destination not found."</li>
          </ul>
          </td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND bot id-->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง bot_id มาผิด</span>
      </header>

      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageboterror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Bot ID not found."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Bot ID not found."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND type -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง type มาผิด</span>
      </header>

      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messagetypeerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Type not support."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Type not support."
          </td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND sticker_id -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง url มาผิดรูปแบบ</span>
      </header>

      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageurlerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"No Url."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "No Url."
          </td>
        </tr>
      </table>
      <br>
      <!-- 400 Parameter error -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerberror">400 BAD REQUEST</span>
          <span class="EndpointUrl">กรณีที่ส่ง พารามิเตอร์ มาผิด</span>
      </header>

      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageparametererror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Parameter error."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Parameter error."
          </td>
        </tr>
      </table>
    </div>



    <!-- mobile -->
    <div class="hidden-md-and-up">
      <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON)</h3>
    <code class="codecolormo" style="">
      <v-tooltip top >
        <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
              <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
               <span>Copy to clipboard</span>
            </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"Uba7xxx6c384xxxa5b3xxxx269b4xxxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150xxxx5d81axxxxxf34b95f218xxxxx"</span>,
    <span class="colorkey">"type"</span> : <span class="colorvalue">"web"</span>,
    <span class="colorkey">"url"</span> : <span class="colorvalue">"https://one.th/"</span>,
    <span class="colorkey">"custom_notification"</span> : <span class="colorvalue">"เปิดอ่านข้อความใหม่จากทางเรา"</span>
  }
    </code>

      <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งไฟล์</h3> -->
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>to</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>ประเภทของข้อความ ในที่นี้เป็น web</td>
        </tr>
        <tr>
          <td>url</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>url ของwebsite ที่ต้องการจะส่ง โดยมีรูปแบบของurlปกติ</td>
        </tr>
        <tr>
          <td>custom_notification</td>
          <td>String</td>
          <td></td>
          <td>ข้อมูลสำหรับแสดงการแจ้งเตือน</td>
        </tr>
      </table>

<br>
      <header class="EndpointHeader">
        <h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbPost">200 OK</span>
          <span class="EndpointUrl">กรณีที่ส่ง request มาถูกต้อง</span>
      </header>

<code class="codecolormo">
<v-tooltip top >
<v-btn flat icon type="button" class="responsefile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageresponsestick">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"message"</span> : {
      <span class="colorkey">"id"</span> : <span class="colorvalue">"5bbxxxxx14e06xxx4b1xxxxx"</span>,
      <span class="colorkey">"url"</span> : <span class="colorvalue">"https://one.th/"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"web"</span>
    },
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">1539144164000</span>,
    <span class="colorkey">"type_source"</span> : <span class="colorvalue">"bot"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150xxxx5d81axxxxxf34b95f218xxxxx"</span>,
    <span class="colorkey">"type_destination"</span> : <span class="colorvalue">"user"</span>,
    <span class="colorkey">"user_id"</span> : <span class="colorvalue">"Uba7xxx6c384xxxa5b3xxxx269b4xxxxx"</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>
      <!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งไฟล์</h3> -->
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>message</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลทั้งหมด ที่เกี่ยวกับข้อความนั้น ๆ ประกอบด้วย
            <ul>
            <li>id คือ เลขเฉพาะที่บ่งบอกถึงข้อความนั้น ๆ</li>
            <li>url คือ ข้อความที่ถูกส่ง ซึ่งจะเป็น url ของ website</li>
            <li>type คือ ประเภทข้อความที่ถูกส่ง ในที่นี้เป็น "web"</li>
          </ul>
          </td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>วันและเวลาที่ส่งข้อความ</td>
        </tr>
        <tr>
          <td>type_source</td>
          <td>String</td>
          <td>ประเภทของบุคคลที่ส่งข้อความ ซึ่งจะเป็น bot หรือ user</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type_destination</td>
          <td>String</td>
          <td>ประเภทของห้องแชทที่ส่ง ซึ่งจะเป็น user หรือ group</td>
        </tr>
        <tr>
          <td>user_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบุคคลนั้น</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          </td>
        </tr>
      </table>
      <br>
      <!-- 401 Authorization fail -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีที่ส่ง Authorization มาผิด</span>
      </header>

      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageauthoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization fail."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Authorization fail."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND to-->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง to มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messagetoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"User ID not found."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด <br>
            <ul>
            <li>"User ID not found."</li>
            <li>"Group ID not found."</li>
            <li>"Destination not found."</li>
          </ul>
          </td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND bot id-->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง bot_id มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageboterror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Bot ID not found."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Bot ID not found."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND type -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง type มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messagetypeerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Type not support."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Type not support."
          </td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND sticker_id -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง url มาผิดรูปแบบ</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageurlerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"No Url."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "No Url."
          </td>
        </tr>
      </table>
      <br>
      <!-- 400 Parameter error -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerberror">400 BAD REQUEST</span>
          <span class="EndpointUrl">กรณีที่ส่ง พารามิเตอร์ มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageparametererror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Parameter error."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Parameter error."
          </td>
        </tr>
      </table>

    </div>
  </div>
</section>

</div>

      </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    urlsendfile: '',
    message: '{\n\t"to":"Uba7xxx6c384xxxa5b3xxxx269b4xxxxx",\n\t"bot_id": "B150xxxx5d81axxxxxf34b95f218xxxxx",\n\t"type": "web",\n\t"url": "https://one.th/",\n\t"custom_notification": "เปิดอ่านข้อความใหม่จากทางเรา"\n}',
    messageresponsestick: '{\n\t"message": {\n\t\t"id": "5bbxxxxx14e06xxx4b1xxxxx",\n\t\t"url": "https://one.th/",\n\t\t"type": "web"\n\t},\n\t"timestamp": 1539144164000,\n\t"type_source": "bot",\n\t"bot_id": "B150xxxx5d81axxxxxf34b95f218xxxxx",\n\t"type_destination": "user",\n\t"user_id": "Uba7xxx6c384xxxa5b3xxxx269b4xxxxx",\n\t"status": "success"\n}',
    messageauthoerror: '{\n\t"status": "fail",\n\t"message": "Authorization fail."\n}',
    messagetoerror: '{\n\t"status": "fail",\n\t"message": "User ID not found."\n}',
    messageboterror: '{\n\t"status": "fail",\n\t"message": "Bot ID not found."\n}',
    messagetypeerror: '{\n\t"status": "fail",\n\t"message": "Type not support."\n}',
    messageurlerror: '{\n\t"status": "fail",\n\t"message": "No Url."\n}',
    messageparametererror: '{\n\t"status": "fail",\n\t"message": "Parameter error."\n}'
  }),
  methods: {

  },
  created () {
    this.urlsendfile = process.env.APIimage + '/api/v1/push_message'
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 90vw;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointVerbfail {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid orange;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: orange;
    color: #FFFFFF;
}
.EndpointVerberror {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid red;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: red;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
    /*cursor: pointer;*/
}
#apifiletable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apifiletable td, #apifiletable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletable tr:nth-child(even){background-color: #f2f2f2;}

#apifiletable tr:hover {background-color: #ddd;}

#apifiletable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


#apifiletablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apifiletablemo td, #apifiletablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletablemo tr:nth-child(even){background-color: #f2f2f2;}

#apifiletablemo tr:hover {background-color: #ddd;}

#apifiletablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


/*.divbutton {
    height: 30px;
    background: #000;
}*/

.requestfile {
    display: none !important;
}

.codecolor:hover .requestfile {
    display: block !important;
}

.urlcopy {

    display: none !important;
}
.EndpointUrl:hover .urlcopy {
    display: inline !important;
}
.responsefile{
    display: none !important;
}

.codecolor:hover .responsefile {
    display: block !important;
}
#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/reply/webhook_replywebview.vue